import type {ParticipantSampleInterface} from "./ParticipantSampleTypes";
import {isNonStandardSample} from "@/features/Orders/helpers/nonStandardSample";

export interface ParticipantSampleLists {
    sampleType: ParticipantSampleInterface[];
    sampleTypeNotInWork: ParticipantSampleInterface[];
}

export function getInvalidParticipantSamples(
    lists: ParticipantSampleLists,
    availableSampleIds: number[],
): ParticipantSampleInterface[] {
    const availableIds = new Set(availableSampleIds);
    const workingIds = new Set(lists.sampleType.map(sample => sample.id));

    return [...lists.sampleType, ...lists.sampleTypeNotInWork].filter(sample =>
        !availableIds.has(sample.id)
        || (workingIds.has(sample.id) && isNonStandardSample(sample))
    );
}
